export const CLIENTS = {
  GET_LIST: 'GET_CLIENTS_LIST',
  REQUEST_ADD: 'REUEST_ADD_CLIENT',
  ADD: 'ADD_CLIENT',
  REQUEST_REMOVE: 'REQUEST_REMOVE_CLIENT',
  REMOVE: 'REMOVE_CLIENT',
  REQUEST_UPDATE: 'REQUEST_UPDATE_CLIENT',
  UPDATE: 'UPDATE_CLIENT',
}
